import {combineReducers} from "redux";
import { sideNavShown, SideNavShownState } from "./sideNav";

export type NavState = {
    sideNavShown: SideNavShownState
}
export default combineReducers({
    sideNavShown,
});
